export const defaultSettings = {
    musicVolume: 1,
    sfxVolume: 0.5,
    caterpillarNess: 1,
    sparksMindMode: false
}